import { combineReducers } from 'redux'
import view from './view'
import layoutGroups from './layoutGroups'
import layouts from './layouts'
import users from './users'
import settings from './settings'
import unreadBoardActivitiesCount from './unreadBoardActivitiesCount'
import boardsBlockerCount from './boardsBlockerCount'
import layoutPermissions from './layoutPermissions'

export default combineReducers({
  view,
  layoutGroupsByKey: layoutGroups,
  layouts,
  users,
  settings,
  unreadBoardActivitiesCount,
  boardsBlockerCount,
  layoutPermissions,
})
